import { baseConfig } from "config";
import AuthTokenHelper from "helpers/AuthTokenHelper";
import { get } from "./axios";

export class StorageService {
	private static baseURL = "terms";
	private static endpoints = {
		upload: "/upload",
		file: "/file",
		replace: "/replace"
	};
	static async uploadFile(
		fileObject: File,
		onUploadProgress?: (percent: number) => void,
		termId?: string
	) {
		let response = new Response();
		onUploadProgress?.(20);
		const token = AuthTokenHelper.getAuthToken();

		onUploadProgress?.(40);

		const formData = new FormData();
		formData.append("file", fileObject);

		onUploadProgress?.(60);

		const tenantString = localStorage.getItem("tenant");
		let tenantId = "";
		if (tenantString) {
			tenantId = JSON.parse(tenantString).value;
		} else {
			throw new Error("tenantId must be used a value");
		}

		onUploadProgress?.(80);

		if (termId) {
			response = await fetch(
				`${baseConfig.baseURL}/${StorageService.baseURL}${StorageService.endpoints.replace}/${termId}`,
				{
					method: "PUT",
					body: formData,
					headers: {
						Authorization: `Bearer ${token}`,
						"Tenant-Id": tenantId
					}
				}
			);
		} else {
			response = await fetch(
				`${baseConfig.baseURL}/${StorageService.baseURL}${StorageService.endpoints.upload}`,
				{
					method: "POST",
					body: formData,
					headers: {
						Authorization: `Bearer ${token}`,
						"Tenant-Id": tenantId
					}
				}
			);
		}

		if (!response.ok) {
			throw new Error("Failed to upload file.");
		}

		onUploadProgress?.(100);
		return response.text();
	}

	static async retrieveFile(fileUrl: string) {
		return get(fileUrl);
	}
}
